// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Menu_dropdown__F2YX1","item":"Menu_item__GGNO9"};